import { createFileRoute } from '@tanstack/react-router';
import { TeamAbsenceCalendar } from '@/features/leave/TeamAbsenceCalendar';

export const Route = createFileRoute('/_app/team-calendar')({ component: TeamAbsenceCalendar });

// Calendario team: assenze approvate + smart working, composto client-side da
// leave-requests + smart-working-requests (nessun endpoint BE dedicato).
